export enum ThreadEntityType {
  accountingPeriod = 'accounting_period',
  vatDeclaration = 'vat_declaration',
  task = 'task',
  bankTransaction = 'bank_transaction',
  corporateTaxInstalment = '2571'
}
